const getAppDeepLink = deepLink => {
    const alteredUrl = deepLink.replace('https://giphy.com/', 'giphy://shortcut/')
    return !alteredUrl.match('giphy://shortcut') ? `giphy://shortcut${alteredUrl}` : alteredUrl
}

export default getAppDeepLink
